import { permissions } from '@vanilla/services/PermissionService.js';

/** Default route when path is empty or access is denied. */
export const DEFAULT_ROUTE = 'deals';

/**
 * Route access map — mirrors New folder RouterManager._canAccessRoute.
 * Restrictive default: unknown routes are denied (caller should fall back to DEFAULT_ROUTE).
 */
export function canAccessRoute(route) {
    const accessMap = {
        leads: () => permissions.canView('leads'),
        deals: () => permissions.canView('deals'),
        calendar: () => permissions.canView('calendar'),
        clients: () => permissions.canView('accounts'),
        contacts: () => permissions.canView('contacts'),
        users: () => permissions.canView('users'),
        dashboard: () => permissions.canView('dashboard'),
        settings: () => permissions.canView('integrations'),
        permissions: () => permissions.canView('permissions'),
        'data-management': () => permissions.canAccessDataManagement(),
        revenue: () => permissions.canView('revenue'),
        goals: () => permissions.canView('goals'),
        commissions: () => permissions.canView('commissions'),
        reports: () => permissions.canView('reports'),
    };
    const check = accessMap[route];
    return check ? check() : false;
}

/** @deprecated Prefer react-router path parsing; kept for dual-read during rollout. */
export function parseHashRoute() {
    const hash = window.location.hash.replace(/^#\/?/, '');
    if (hash) {
        const parts = hash.split('/').filter(Boolean);
        return { route: parts[0] || DEFAULT_ROUTE, sub: parts[1] || null };
    }
    const parts = (window.location.pathname || '/').split('/').filter(Boolean);
    return { route: parts[0] || DEFAULT_ROUTE, sub: parts[1] || null };
}

/** Drop session path/hash without a full navigation. */
export function clearSessionRoute() {
    const path = window.location.pathname || '/';
    const search = window.location.search || '';
    if (!window.location.hash && path === '/') return;
    window.history.replaceState(null, '', `${path === '/' ? '/' : path}${search}`);
    if (window.location.hash) {
        window.history.replaceState(null, '', `${path}${search}`);
    }
}

/** Programmatic navigation helper — History API path. */
export function navigateRoute(name, sub = null) {
    const path = sub ? `/${name}/${sub}` : `/${name}`;
    if (window.__CRM_NAVIGATE__) {
        window.__CRM_NAVIGATE__(path);
        return;
    }
    window.history.pushState(null, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
}

export function buildDealPath(dealId, opts = {}) {
    const id = String(dealId || '').trim();
    if (!id) return '/deals';
    const qs = new URLSearchParams();
    if (opts.tab) qs.set('tab', String(opts.tab));
    if (opts.highlight) qs.set('highlight', String(opts.highlight));
    if (opts.filter) qs.set('filter', String(opts.filter));
    const q = qs.toString();
    return `/deals/${encodeURIComponent(id)}${q ? `?${q}` : ''}`;
}

export function absoluteAppUrl(pathAndQuery) {
    const base = String(pathAndQuery || '/');
    if (/^https?:\/\//i.test(base)) return base;
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    return `${origin}${base.startsWith('/') ? base : `/${base}`}`;
}
